export default __webpack_public_path__ + "locales/el-GR/CreateEditRoomDialog.json?hash=023ba474e851b70e717d07eda8d9f77c";